'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setTeamMembers = exports.removeTeamMember = exports.fetchAndAddTeamMember = exports.addNewTeamMember = exports.addTeamMember = undefined;

var _userUtil = require('../../userUtil');

var _userService = require('../../userService');

var _formActions = require('../../../components/form/formActions');

var _teamManagementConstants = require('./teamManagementConstants');

var _teamFormConstants = require('./form/teamFormConstants');

// Actions
var addTeamMember = exports.addTeamMember = function addTeamMember(_ref) {
    var userId = _ref.userId;
    return { type: _teamManagementConstants.TEAM_MEMBER_ADD, userId: userId };
}; // Util
var addNewTeamMember = exports.addNewTeamMember = function addNewTeamMember(_ref2) {
    var userId = _ref2.userId;
    return { type: _teamManagementConstants.TEAM_MEMBER_ADD_NEW, userId: userId };
};

var fetchAndAddTeamMember = exports.fetchAndAddTeamMember = function fetchAndAddTeamMember(_ref3) {
    var userEmail = _ref3.userEmail;
    return function (dispatch, getState) {
        var lowerCaseUserEmail = userEmail.toLowerCase();

        return dispatch((0, _userService.getOrInviteUser)({ userEmail: lowerCaseUserEmail })).then(function (user) {
            if (!user._id) return;

            if ((0, _userUtil.isSubscribed)(user)) {
                return dispatch((0, _formActions.formSubmissionFailed)({
                    form: _teamFormConstants.ADD_TEAM_MEMBER_FORM_NAME,
                    primaryError: {
                        message: user.email + ' already has a subscription.' + 'They will need to unsubscribe before they can be added to this team.'
                    },
                    errorCode: 'ALREADY_SUBSCRIBED',
                    reportError: false
                }));
            }

            return dispatch(addNewTeamMember({ userId: user._id }));
        }).catch(function (err) {
            return console.error(err);
        });
    };
};

var removeTeamMember = exports.removeTeamMember = function removeTeamMember(_ref4) {
    var userId = _ref4.userId;
    return { type: _teamManagementConstants.TEAM_MEMBER_REMOVE, userId: userId };
};

var setTeamMembers = exports.setTeamMembers = function setTeamMembers(_ref5) {
    var userIds = _ref5.userIds;
    return { type: _teamManagementConstants.TEAM_MEMBERS_SET, userIds: userIds };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/team/teamManagementActions.js
// module id = 310
// module chunks = 0